module.exports = __webpack_public_path__ + "img/loyalty-voucher-title-img.c6b6beb2.webp";